// Utils
import { isSharedWithOthers } from '../utils/sharing-utils';
import * as i0 from "@angular/core";
/**
 * Returns true if the item is shared with other users.
 *
 * Params:
 *   string: The string with words to be abbreviated.
 */
export class IsSharedWithOthersPipe {
    transform(item) {
        return isSharedWithOthers(item);
    }
}
IsSharedWithOthersPipe.ɵfac = function IsSharedWithOthersPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IsSharedWithOthersPipe)(); };
IsSharedWithOthersPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isSharedWithOthers", type: IsSharedWithOthersPipe, pure: true, standalone: false });
